module.exports = __webpack_public_path__ + "media/images/logo-12c2453ad416a1e72b7b3f1fee64ffd2.png";